import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import styled,{ ThemeProvider} from 'styled-components';
import { Provider } from 'react-redux';
import mgpStore from 'Stores/Store';
import App from './App';
import GlbStyle from 'Assets/GlbStyle';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider}from "react-query";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {MainThm} from 'Assets/GlbThm';
import ReactPixel from 'react-facebook-pixel';
import "Assets/css/Font/zwicon.css"
import ScrollToTop from 'Utils/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import { clearNavigator, setNavigator } from 'Utils/navigationService';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const headerHeight = process.env.REACT_APP_GLOBAL_HEADER_HEIGHT || "50";
document.documentElement.style.setProperty('--global-header-height', `${headerHeight}px`);
// 모바일 100vh 대응: --vh CSS 변수 동적 세팅 (디바운스 적용)
// 모바일 100vh 대응: --vh CSS 변수 동적 세팅 (최초 1회만 적용)
function setVh() {
  let vh;
  if (window.matchMedia('(orientation: landscape)').matches) {
    // 가로모드: 기기 세로 전체 길이 사용
    vh = window.screen.height * 0.01;
  } else {
    // 세로모드: 실제 뷰포트 높이 사용
    vh = window.innerHeight * 0.01;
  }
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVh();
const queryClient = new QueryClient();
root.render(

    <HelmetProvider>
      <BrowserRouter >
      <NavigationRegistrar />
      <ScrollToTop />
        <ThemeProvider theme={MainThm}>
          <GlbStyle /> 
          <Provider store={mgpStore}>
              <QueryClientProvider client={queryClient}>
                <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!} useRecaptchaNet={true}>
                  {/* Warmup component ensures executeRecaptcha is ready after SPA navigation */}
                  <ReCaptchaWarmup />
                  <App />
                </GoogleReCaptchaProvider>
              </QueryClientProvider>
          </Provider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function ReCaptchaWarmup() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const location = useLocation();
  React.useEffect(() => {
    let iv: number | null = null;
    let to: number | null = null;
    const tryWarm = async () => {
      if (!executeRecaptcha) return;
      try {
        await executeRecaptcha('warmup');
        // eslint-disable-next-line no-console
        console.debug('[reCAPTCHA] warmup success', location.pathname);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[reCAPTCHA] warmup failed', e);
      }
    };
    if (executeRecaptcha) {
      tryWarm();
    } else {
      iv = window.setInterval(() => {
        if ((executeRecaptcha as any)) {
          tryWarm();
          if (iv) { clearInterval(iv); iv = null; }
        }
      }, 200);
      to = window.setTimeout(() => {
        if (iv) { clearInterval(iv); iv = null; }
        // eslint-disable-next-line no-console
        console.warn('[reCAPTCHA] warmup timeout', location.pathname);
      }, 3000);
    }
    return () => {
      if (iv) clearInterval(iv);
      if (to) clearTimeout(to);
    };
  }, [executeRecaptcha, location.pathname]);
  return null;
}

function NavigationRegistrar() {
  const navigate = useNavigate();

  React.useEffect(() => {
    setNavigator(navigate);
    return () => clearNavigator();
  }, [navigate]);

  return null;
}
